import { Badge, BadgeId, BadgesStats } from './Models';
import { allBadges } from './AllBadges/allBadges';
import { WritingBadge } from './AllBadges/WritingBadge';

const evaluateAchievedWritingBadges = (stats: BadgesStats): ReadonlyArray<WritingBadge> => {
  return allBadges.filter(badge => {
    if (badge instanceof WritingBadge) {
      return badge.evaluateIfAchieved(stats);
    } else {
      return false;
    }
  }) as ReadonlyArray<WritingBadge>;
};

export const getNewAchievedWritingBadges = (
  stats: BadgesStats,
  oldAchievedBadgesIds: ReadonlyArray<BadgeId>,
): ReadonlyArray<Badge> => {
  const allAchieved = evaluateAchievedWritingBadges(stats);
  const newAchieved = allAchieved.filter(badge => {
    return !oldAchievedBadgesIds.includes(badge.id);
  });
  return newAchieved;
};



// WEBPACK FOOTER //
// ./src/containers/Badges/Logic.ts